import Chart from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import React, { Component } from 'react';
import { format } from 'date-fns';
export default class Chart_garmin_daily_hr extends Component {
    constructor(props) {
        super(props);
        //this.chartRef = React.createRef();
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.data !== this.props.data) {
            this.componentDidMount();
        }
    }
    componentDidMount() {
        //const myChartRef = this.chartRef.current.getContext("2d");
        var ctx = document.getElementById('Chart_garmin_daily_hr').getContext('2d');
        const date = this.props.data[0]['timeoffsetheartrate'];
        const data = this.props.data[0]['timeoffsetheartrate'];
        var x_data = [];
        var y_data = [];
        for (var i = 0; i < data.length - 1; i++) {
            x_data.push(data[i][1]);
            var tmp = format(new Date(date[i][0]), "HH:mm:ss");
            y_data.push(tmp);
        }
        console.log(y_data)
        var isstepped = false;
        if (window.Chart_garmin_daily_hr instanceof Chart) window.Chart_garmin_daily_hr.destroy();
        window.Chart_garmin_daily_hr = new Chart(ctx, {
            type: "scatter",
            // plugins: [ChartDataLabels],
            data: {
                //Bring in data
                labels: y_data,
                datasets: [
                    {
                        label: 'Heart Rate',
                        data: x_data,
                        steppedLine: isstepped,
                        backgroundColor: '#ff0000',
                        borderColor: '#ff0000',
                        fill: false,
                        tension: '0',
                        datalabels: {
                            display: false
                        }
                    }
                ]
            },
            options: {
                //Customize chart options
                responsive: true,
                legend: {
                    display: false
                },
                scales: {
                    xAxes: [{
                        type: 'time',
                        offset: true,
                        time: {
                            format: "HH:mm:ss",
                            unit: 'second',
                            unitStepSize: 1,
                            displayFormats: {
                                'second': 'HH:mm:ss',
                                'minute': 'HH:mm',
                                'hour': 'HH:mm'
                            }
                        }
                    }]
                },
                elements: {
                    point: {
                        radius: 1.5
                    }
                },
                title: {
                    display: false,
                    text: "Daily Heart Rate",
                    fontSize: 30,
                    fontFamily: 'Noto Sans CJK TC'
                }
            }
        });
    }
    render() {
        return (
            <div>
                <script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.9.4/Chart.js"></script>
                <canvas id="Chart_garmin_daily_hr"></canvas>
            </div>
        );
    }
}